import { DeleteEventReq } from './api.types';
import ApiClient, { apiClient } from './axios-wrapper';
import {
  CreateTeacherBusyReq,
  TeacherBusyModel,
  UpdateTeacherBusyReq,
} from './teacher-busy.types';

class TeacherBusyService {
  private readonly api: ApiClient;
  constructor() {
    this.api = apiClient;
  }

  async findOne(id: number): Promise<TeacherBusyModel> {
    return await this.api.get<TeacherBusyModel>(`/teacher-busy/${id}`, {
      hideToast: true,
    });
  }

  async create(
    createTeacherBusyReq: CreateTeacherBusyReq
  ): Promise<TeacherBusyModel> {
    return this.api.post<CreateTeacherBusyReq, TeacherBusyModel>(
      '/teacher-busy',
      createTeacherBusyReq
    );
  }

  async findAll(
    teacherId: number,
    startDate: Date,
    endDate: Date
  ): Promise<TeacherBusyModel[]> {
    return this.api.get<TeacherBusyModel[]>(
      `/teacher-busy/teacher/${teacherId}`,
      { params: { startDate, endDate } }
    );
  }

  async update(
    id: number,
    data: UpdateTeacherBusyReq
  ): Promise<TeacherBusyModel> {
    return await this.api.patch<UpdateTeacherBusyReq, TeacherBusyModel>(
      `/teacher-busy/${id}`,
      data
    );
  }

  async delete(id: number, data: DeleteEventReq): Promise<TeacherBusyModel> {
    return await this.api.delete<TeacherBusyModel>(`/teacher-busy/${id}`, {
      data,
    });
  }
}

export const teacherBusyService = new TeacherBusyService();
